<script setup lang="ts">
import { onMounted, ref } from 'vue'
import type { Article, Service } from '@/types'
import { articles, categories, PATHS } from '@/content'
import { pickServiceNews } from '../../scripts/lib/service-news.mjs'
import ArticleCard from '@/components/ArticleCard.vue'

/**
 * Section "Actualites" en bas de certaines pages de services : remplace le widget
 * WordPress dont l'import n'avait garde que le texte d'attente. Articles de la categorie
 * la plus proche de la page. Rendus au build (liens visibles des moteurs), puis
 * rafraichis en direct depuis le blog live pour inclure les articles publies depuis.
 */
const props = defineProps<{ service: Service }>()

const items = ref<Article[]>(pickServiceNews(props.service, articles, categories, 3))

onMounted(async () => {
  try {
    const q = new URLSearchParams({ path: props.service.path, title: props.service.title || '' })
    const res = await fetch(`/__live/service-news?${q}`, { headers: { accept: 'application/json' } })
    if (!res.ok) return
    const fresh = (await res.json()) as Article[]
    if (Array.isArray(fresh) && fresh.length) items.value = fresh
  } catch {
    /* selection du build conservee */
  }
})
</script>

<template>
  <section v-if="items.length" class="section news">
    <div class="container">
      <span class="eyebrow">Actualités</span>
      <h2>Nos derniers articles sur le sujet</h2>
      <div class="grid grid--3 news__grid">
        <ArticleCard v-for="a in items" :key="a.path" :article="a" />
      </div>
      <p class="news__more">
        <router-link :to="PATHS.blog" class="btn btn--outline">Voir tous les articles</router-link>
      </p>
    </div>
  </section>
</template>

<style scoped>
.news__grid {
  margin-top: 22px;
}
.news__more {
  margin: 28px 0 0;
  text-align: center;
}
</style>
